import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09d207f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "panel chart-panel" }
const _hoisted_2 = { class: "panel-head" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "市场情绪趋势", -1))
const _hoisted_4 = { class: "index-toggles" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "panel-body" }
const _hoisted_7 = {
  key: 1,
  class: "empty-tip"
}
const _hoisted_8 = { class: "panel thermo-panel-wrap" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", { class: "panel-head" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "市场情绪温度")
], -1))
const _hoisted_10 = { class: "panel-body" }
const _hoisted_11 = { class: "panel table-panel" }
const _hoisted_12 = { class: "panel-head" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "情绪解读&操作信号", -1))
const _hoisted_14 = { class: "panel-head-update-time" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "update-label" }, "更新时间：", -1))
const _hoisted_16 = { class: "update-value" }
const _hoisted_17 = { class: "panel-body table-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TrendChart = _resolveComponent("TrendChart")!
  const _component_JfNoData = _resolveComponent("JfNoData")!
  const _component_ThermometerPanel = _resolveComponent("ThermometerPanel")!
  const _component_StageTable = _resolveComponent("StageTable")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["sentiment-trend-page", _ctx.theme]),
    style: _normalizeStyle(_ctx.pageStyle)
  }, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("header", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.indexOptions, (opt) => {
            return (_openBlock(), _createElementBlock("button", {
              key: opt.key,
              type: "button",
              class: _normalizeClass(["toggle-btn", { active: _ctx.selectedIndexes.includes(opt.key) }]),
              onClick: ($event: any) => (_ctx.toggleIndex(opt.key))
            }, _toDisplayString(opt.label), 11, _hoisted_5))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_ctx.rangeList.length)
          ? (_openBlock(), _createBlock(_component_TrendChart, {
              key: 0,
              list: _ctx.rangeList,
              "selected-indexes": _ctx.selectedIndexes,
              theme: _ctx.theme,
              "font-scale": _ctx.chartFontScale,
              activeIndex: _ctx.activePointIndex,
              "onUpdate:activeIndex": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activePointIndex) = $event))
            }, null, 8, ["list", "selected-indexes", "theme", "font-scale", "activeIndex"]))
          : (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, "加载中..."))
            : (_openBlock(), _createBlock(_component_JfNoData, {
                key: 2,
                theme: _ctx.theme
              }, null, 8, ["theme"]))
      ])
    ]),
    _createElementVNode("section", _hoisted_8, [
      _hoisted_9,
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_ThermometerPanel, {
          score: _ctx.currentScore,
          "trading-day": _ctx.currentTradingDay,
          theme: _ctx.theme,
          "font-scale": _ctx.fontScale
        }, null, 8, ["score", "trading-day", "theme", "font-scale"])
      ])
    ]),
    _createElementVNode("section", _hoisted_11, [
      _createElementVNode("header", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.currentUpdateTimeText), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_StageTable, {
          score: _ctx.currentScore,
          theme: _ctx.theme
        }, null, 8, ["score", "theme"])
      ])
    ])
  ], 6))
}